import React from 'react';
import '../fonts.css';
import HoverText from '../components/aboutpagecomponents/bubble';
import HoverText1 from '../components/aboutpagecomponents/bubble1';
// import HoverText2 from '../components/aboutpagecomponents/bubble2';
import HoverText3 from '../components/aboutpagecomponents/bubble3';
import { TextGenerateEffectDemo } from '../components/aboutpagecomponents/textGenerate.jsx';
import CardWrapper from '../components/aboutpagecomponents/card';
// import Horizontalanimatecard from '../components/aboutpagecomponents/horizontalCorousal';
import {AppleCardsCarouselDemo} from '../components/aboutpagecomponents/gallery';
import Footer from '../components/footer';


function About() {
  document.body.style = 'background: black;';
  return (
    <div>
      <div className='max-w-[1400px] mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center'>
        <HoverText />
        <TextGenerateEffectDemo />
      </div>

      <HoverText1 />
      <CardWrapper />

      {/* <div>
        <HoverText2 />
        <Horizontalanimatecard />
      </div> */}

      <div>
        <HoverText3 />
        <AppleCardsCarouselDemo/> 
      </div>
      
      {/* Integrating the Gallery component at the end */}
      
    </div>
  );
}

export default About;
